function scrollToElem() {
	const $anchors = document.querySelectorAll("[data-href]");

	if ($anchors) {
		$anchors.forEach((anchor) => {
			const targetData = anchor.getAttribute("data-href");
			scrollto(anchor, targetData);
		});
	}
}

export default scrollToElem;

const scrollto = (anchor, targetData) => {
	const target = document.querySelector(`[data-jsmodule="${targetData}"]`);
	const $header = document.querySelector(".header");
	anchor.addEventListener("click", (e) => {
		e.preventDefault();
		if (target) {
			const scrollValue = target.getBoundingClientRect().top + window.scrollY;
			let offset = 0;
			if ($header) {
				offset = $header.getBoundingClientRect().height + 10;
			}

			window.scrollTo({
				top: scrollValue - offset,
				left: 0,
				behavior: "smooth",
			});
		}
	});
};
